import React from 'react';
import { ArrowRight, ChevronDown } from 'lucide-react';
import { heroContent } from '../data/mock';

const HeroSection = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero-section">
      <div className="container-custom relative z-10">
        <div className="max-w-4xl">
          {/* Gold accent line */}
          <div className="gold-line mb-8 animate-fade-in" style={{ animationDelay: '0.2s' }} />
          
          {/* Headline */}
          <h1 
            className="text-4xl md:text-5xl lg:text-6xl font-semibold mb-6 animate-fade-in-up"
            style={{ animationDelay: '0.3s', lineHeight: '1.15' }}
          >
            {heroContent.headline}
          </h1>
          
          {/* Subheadline */}
          <p 
            className="text-lg md:text-xl mb-10 max-w-2xl animate-fade-in-up"
            style={{ 
              animationDelay: '0.5s',
              color: 'var(--text-secondary)',
              lineHeight: '1.7'
            }}
          >
            {heroContent.subheadline}
          </p>
          
          {/* CTAs */}
          <div 
            className="flex flex-col sm:flex-row gap-4 animate-fade-in-up"
            style={{ animationDelay: '0.7s' }}
          >
            <button
              onClick={() => scrollToSection('portfolio')}
              className="btn-primary"
            >
              {heroContent.ctaPrimary}
              <ArrowRight size={18} />
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="btn-secondary"
            >
              {heroContent.ctaSecondary}
            </button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div 
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-fade-in"
        style={{ animationDelay: '1s' }}
      >
        <button
          onClick={() => scrollToSection('about')}
          className="flex flex-col items-center gap-2 bg-transparent border-none cursor-pointer"
          style={{ color: 'var(--text-muted)' }}
        >
          <span className="text-sm tracking-wider uppercase">Scroll</span>
          <ChevronDown size={20} className="animate-bounce" style={{ color: 'var(--accent-gold)' }} />
        </button>
      </div>
    </section>
  );
};

export default HeroSection;
